import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback, useMemo, useState } from 'react';
import { Button } from "../../../Button";
import { EyeClosedIcon, EyeOpenIcon } from "../../../icons";
import { CoreInput } from "./CoreInput";
var PasswordInput = function PasswordInput(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isTypePassword = _useState2[0],
    setIsTypePassword = _useState2[1];
  var Icon = useMemo(function () {
    return isTypePassword ? EyeClosedIcon : EyeOpenIcon;
  }, [isTypePassword]);
  var currentType = useMemo(function () {
    return isTypePassword ? 'password' : 'text';
  }, [isTypePassword]);
  var toggleInputType = useCallback(function (event) {
    var _props$inputProps$onC, _props$inputProps;
    (_props$inputProps$onC = (_props$inputProps = props.inputProps).onClick) === null || _props$inputProps$onC === void 0 ? void 0 : _props$inputProps$onC.call(_props$inputProps, event, isTypePassword);
    setIsTypePassword(!isTypePassword);
  }, [isTypePassword]);
  return /*#__PURE__*/React.createElement(CoreInput, _extends({}, props, {
    rightAside: /*#__PURE__*/React.createElement(Button, {
      disabled: props.disabled,
      icon: /*#__PURE__*/React.createElement(Icon, {
        fill: props.disabled && !(props !== null && props !== void 0 && props.readOnly) ? '#A7ABB0' : '#5a5e62',
        size: "s"
      }),
      onClick: toggleInputType,
      type: "button",
      variant: "plain"
    }),
    type: currentType,
    "data-t-id": "Input-components"
  }));
};
export { PasswordInput };